<template>
  <v-badge
    :color="badgeColor"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-badge>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Badge extends Vue {
  @Prop({ type: String, default: '' })
  color!: string;

  get badgeColor() {
    return this.color ? this.color : 'error darken-4';
  }
}
</script>
